import { createApp } from 'vue';
import http from './plugins/http';
import CategoryProducts from '../components/products/CategoryProducts.vue';

document.addEventListener( 'DOMContentLoaded', () => {
    const slug  = window.categorySlug;
    const title = window.categoryName;
    if ( ! slug || ! title ) return;

    const el = document.getElementById( 'categoryProductsApp' );
    const app = createApp( CategoryProducts, {
        slug  : slug,
        title : title,
    } );
    app.use(http);
    app.mount(el);
} );